import { jsxs as t, jsx as o } from "react/jsx-runtime";
import { Icon as b } from "@blueprintjs/core";
import { IconNames as f } from "@blueprintjs/icons";
import i from "classnames";
import { useState as v } from "react";
import N from "react-animate-height";
import "./main.scss";
const c = { SMALL: 16, LARGE: 24 }, u = ({
  title: n,
  content: a,
  chevronSize: r = c.LARGE,
  renderExpanded: d = !0,
  fill: _ = !1,
  rightHeaderContent: p = void 0,
  className: m = void 0
}) => {
  const [e, l] = v(d);
  return /* @__PURE__ */ t(
    "div",
    {
      className: i(
        "sds_collapsible-section",
        {
          "sds_collapsible-section--collapsed": !e
        },
        m
      ),
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: "sds_collapsible-section__header",
            onClick: () => l((s) => !s),
            onKeyDown: (s) => {
              s.key === "Enter" && l((h) => !h);
            },
            role: "button",
            tabIndex: 0,
            children: [
              /* @__PURE__ */ o(
                "div",
                {
                  className: i("sds_collapsible-section__header__title", {
                    "sds_collapsible-section__header__title--fill": _
                  }),
                  children: n
                }
              ),
              /* @__PURE__ */ o(
                b,
                {
                  className: i("sds_collapsible-section__header__chevron", {
                    "sds_collapsible-section__header__chevron--up": e
                  }),
                  title: e ? "Close" : "Open",
                  icon: f.CHEVRON_DOWN,
                  size: r
                }
              ),
              p
            ]
          }
        ),
        /* @__PURE__ */ o(N, { duration: 300, height: e ? "auto" : 0, children: a })
      ]
    }
  );
};
u.ChevronSize = c;
export {
  u as CollapsibleSection
};
//# sourceMappingURL=index.js.map
